import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import loadingBarImg from '../../images/loadingAnimation.gif';
import '../Modules/LoadingBar/LoadingBar.less';


const LoadingBar = ({ show, overrideShow }) => {
  const showOrHide = (show || overrideShow) ? '' : ' hide';
  return (
    <div className={`loading-bar${showOrHide}`}>
      <img src={loadingBarImg} alt="" />
    </div>
  );
};

LoadingBar.defaultProps = {
  overrideShow: false,
};

LoadingBar.propTypes = {
  show: PropTypes.bool.isRequired,
  overrideShow: PropTypes.bool,
};

function mapStateToProps(state) {
  return { show: state.get('loadingSpinner')};
}

export default connect(mapStateToProps)(LoadingBar);



// WEBPACK FOOTER //
// ./src/components/common/LoadingBar.js